export enum CMSNotificationType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
}

export function extractCMSNotificationMessage(notificationsData: any, notificationType: CMSNotificationType, notificationKey?: string | number): string {
    
    notificationKey = notificationKey ? notificationKey : notificationType;
    let notification: string = '';

    if (notificationsData?.content) {
        notification = notificationsData.content.find((notification: any) => notification.key == notificationKey)?.dname 
        || notificationsData.content.find((notification: any) => notification.key == notificationType)?.dname;
    }

    return notification;
}